// review-draft-derive.ts — P6-5 deterministic (no-AI) weekly/monthly review draft.
// Reuses buildReviewSummary's pure stats to pre-fill the reflection so users
// without AI still get a number-backed starting point. Pure + testable.
import { buildReviewSummary } from "../lib/ai/review-summary";
import { formatMoney } from "../lib/date";
import type { LifeOsState } from "../types";

export type ReviewDraft = { reflection: string; wins: string; blockers: string };

export function buildReviewDraft(
  state: LifeOsState,
  scope: "week" | "month",
  today: string,
): ReviewDraft {
  const s = buildReviewSummary(state, scope, today);
  const st = s.stats;
  const net = st.netCashflow;
  const reflection =
    `Tổng kết ${s.periodLabel}: hoàn thành ${st.doneCount} việc, ${st.habitCompletions} lượt thói quen; ` +
    `${st.activeProjects} dự án & ${st.activeGoals} mục tiêu đang theo. ` +
    `Dòng tiền ${net >= 0 ? "+" : "−"}${formatMoney(Math.abs(net))}.`;
  const wins = s.doneTitles.length ? s.doneTitles.map((t) => `• ${t}`).join("\n") : "";
  const blockers = st.deferredCount > 0
    ? `${st.deferredCount} việc bị hoãn trong kỳ — rà soát nguyên nhân.`
    : "";
  return { reflection, wins, blockers };
}
